import permissionMixin from '@/helpers/mixins/permissionMixin'
import jsPDF from 'jspdf'

export default {
  data() {
    ;[permissionMixin]
    return {}
  },
  methods: {
    printCSV(checkedRows) {
      //console.log(checkedRows[0].company)
      //console.log(this.isHistoryViewable(checkedRows[0].company))
      if (this.isHistoryViewable(checkedRows[0].company)) {
        this.getCSV(checkedRows)
      } else {
        this.getNoHistoryCSV(checkedRows)
      }
    },
    getNoHistoryCSV(checkedRows) {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent +=
        this.$options.filters.capitalize(this.$translate('order_id')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('client_code')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('customer')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('shop')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('date')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('orderType')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('orderTypetext')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('orderTypeVariant')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('model')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('deliverySelected')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('patient')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('primaryCode')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('secondaryCode')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('prec_pair')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('track_numbe')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('expectedDeliveryDate')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('id_mercury')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('delivery_address')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('subtitle_form_order_production')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('subtitle_form_order_companion')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('claim')) +
        '\n'

      checkedRows.forEach(row => {
        let materialprodstring = ''
        let materialaccstring = ''
        let claimString = ''

        //let creationDate = new Date(row.creationDate).toLocaleDateString()
        //let creationUsername = row.tec

        if (row.claims && Array.isArray(row.claims)) {
          for (let claim of row.claims) {
            claimString += claim.primaryCode ? `${claim.primaryCode} ` : ''
            claimString += claim.tec ? `${claim.tec} ` : ''
            claimString += claim.creationDate ? `${new Date(claim.creationDate).toLocaleDateString()} ` : ''
            claimString += claim.answertec ? `${claim.answertec} ` : '* '
            claimString += claim.answercreationDate
              ? `${new Date(claim.answercreationDate).toLocaleDateString()} `
              : '*'
            claimString += '-'
          }
          claimString = claimString.substring(0, claimString.length - 1)
        }

        if (row.materialprod) {
          for (let key in row.materialprod) {
            materialprodstring += `${row.materialprod[key].qty} x ${this.$translate(row.materialprod[key].name)}-`
          }
          materialprodstring = materialprodstring.substring(0, materialprodstring.length - 1)
        }

        if (row.materialacc) {
          for (let key in row.materialacc) {
            materialaccstring += `${row.materialacc[key].qty} x ${this.$translate(row.materialacc[key].name)}-`
          }
          materialaccstring = materialaccstring.substring(0, materialaccstring.length - 1)
        }

        csvContent += `${row.id};${row.company.mercurio_id ? row.company.mercurio_id : ''};${row.company.name}; ${
          row.shop.name
        }; ${row.send_date ? new Date(row.send_date).toLocaleDateString() : ''}; ${this.$translate(
          row.orderType
        )};${this.$translate(row.orderTypeMain)}; ${this.$translate(row.orderTypeVariant)} - ${
          row.orderTypeSubVariant ? this.$translate(row.orderTypeSubVariant) : ''
        };${this.getCSVModelName(row)}; ${this.$translate(row.deliverySelected)} - ${this.$translate(
          row.deliverySelectedSub
        )}; ${row.patient.alias ? row.patient.alias : ''} - ${row.patient.name ? row.patient.name : ' '} ${
          row.patient.surname ? row.patient.surname : ''
        };${row.primaryCode ? row.primaryCode : ''};${row.secondaryCode ? row.secondaryCode : ''};${
          row.prec_pair ? row.prec_pair : ''
        };${row.track_number ? row.track_number : ''};${
          row.deliveryDate ? new Date(row.deliveryDate).toLocaleDateString() : ''
        };${row.id_mercury ? row.id_mercury : ''};${row.company.address.street} ${row.company.address.city} ${
          row.company.address.postalCode
        } ${this.$translate(row.company.address.country)};${materialprodstring};${materialaccstring};${claimString}\n`
      })
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      let filename = ''
      if (checkedRows.length == 1) {
        filename = checkedRows[0].primaryCode
        filename += '_'
        if (checkedRows[0].patient.alias) {
          filename += checkedRows[0].patient.alias
        } else {
          filename += checkedRows[0].patient.name + '_' + checkedRows[0].patient.surname
        }
        filename += '_'
        filename += new Date().toLocaleDateString()
        filename += '.csv'
      } else {
        filename = this.$options.filters.capitalize(this.$translate('list'))
        filename += '_'
        filename += this.$store.getters.user.userInfo.name
        filename += this.$store.getters.user.userInfo.surname
        filename += '_'
        filename += new Date().toLocaleDateString()
        filename += '_'
        filename += new Date().getHours()
        filename += '_'
        filename += new Date().getMinutes()
        filename += '_'
        filename += new Date().getSeconds()
        filename += '.csv'
      }

      link.setAttribute('download', filename)

      document.body.appendChild(link)
      link.click()
    },
    getCSV(checkedRows) {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent +=
        this.$options.filters.capitalize(this.$translate('order_id')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('client_code')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('customer')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('shop')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('date')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('orderType')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('orderTypetext')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('orderTypeVariant')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('model')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('deliverySelected')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('patient')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('primaryCode')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('secondaryCode')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('prec_pair')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('track_numbe')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('expectedDeliveryDate')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('id_mercury')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('delivery_address')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('subtitle_form_order_production')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('subtitle_form_order_companion')) +
        ';' +
        this.$options.filters.capitalize(this.$translate('created')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('created')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('mark_envo')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('mark_envo')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('sendord_in')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('sendord_in')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('proc_order')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('proc_order')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('waitord')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('waitord')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('workord')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('workord')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('endord')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('endord')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('courier')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('courier')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('processed')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('processed')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('closed')) +
        ' - ' +
        this.$translate('date') +
        ';' +
        this.$options.filters.capitalize(this.$translate('closed')) +
        ' - ' +
        this.$translate('username') +
        ';' +
        this.$options.filters.capitalize(this.$translate('claim')) +
        '\n'

      checkedRows.forEach(row => {
        let materialprodstring = ''
        let materialaccstring = ''
        // let creationString = "";
        // let invordString = this.getCSVString(row.history, 'invord');
        // let sendordString = this.getCSVString(row.history, 'sendord');
        // let proc_orderString = this.getCSVString(row.history, 'proc_order');
        // let waitordString = this.getCSVString(row.history, 'waitord');
        // let workordString = this.getCSVString(row.history, 'workord');
        // let endordString = this.getCSVString(row.history, 'endord');
        // let courierString = this.getCSVString(row.history, 'courier');
        // let processedString = this.getCSVString(row.history, 'processed')
        // let closedString = this.getCSVString(row.history, 'closed');
        let claimString = ''

        // creationString =
        //   row.tec + " " + new Date(row.creationDate).toLocaleDateString();

        let creationDate = new Date(row.creationDate).toLocaleDateString()
        let creationUsername = row.tec

        //console.log(row)
        //console.log(row.claims)
        if (row.claims && Array.isArray(row.claims)) {
          for (let claim of row.claims) {
            //console.log(claim)
            if (claim.primaryCode) claimString += claim.primaryCode
            claimString += ' '
            if (claim.tec) claimString += claim.tec
            claimString += ' '
            if (claim.creationDate) {
              claimString += new Date(claim.creationDate).toLocaleDateString()
            }
            claimString += ' '
            if (claim.answercreationDate) {
              if (claim.answertec) claimString += claim.answertec
              claimString += ' '
              claimString += new Date(claim.answercreationDate).toLocaleDateString()
            } else {
              claimString += '*'
              claimString += ' '
              claimString += '*'
            }
            claimString += '-'
          }

          claimString = claimString.substring(0, claimString.length - 1)
        }

        if (row.materialprod) {
          for (let key in row.materialprod) {
            materialprodstring += row.materialprod[key].qty + ' x ' + this.$translate(row.materialprod[key].name)
            materialprodstring += '-'
          }
        }
        materialprodstring = materialprodstring.substring(0, materialprodstring.length - 1)

        if (row.materialacc) {
          for (let key in row.materialacc) {
            materialaccstring += row.materialacc[key].qty + ' x ' + this.$translate(row.materialacc[key].name)
            materialaccstring += '-'
          }
        }
        materialaccstring = materialaccstring.substring(0, materialaccstring.length - 1)

        csvContent += `${row.id};${row.company.mercurio_id ? row.company.mercurio_id : ''};${row.company.name}; ${
          row.shop.name
        }; ${row.send_date ? new Date(row.send_date).toLocaleDateString() : ''}; ${this.$translate(
          row.orderType
        )};${this.$translate(row.orderTypeMain)}; ${this.$translate(row.orderTypeVariant)} - ${
          row.orderTypeSubVariant ? this.$translate(row.orderTypeSubVariant) : ''
        };${this.getCSVModelName(row)}; ${this.$translate(row.deliverySelected)} - ${this.$translate(
          row.deliverySelectedSub
        )}; ${row.patient.alias ? row.patient.alias : ''} - ${row.patient.name ? row.patient.name : ' '} ${
          row.patient.surname ? row.patient.surname : ''
        };${row.primaryCode ? row.primaryCode : ''};${row.secondaryCode ? row.secondaryCode : ''};${
          row.prec_pair ? row.prec_pair : ''
        };${row.track_number ? row.track_number : ''};${
          row.deliveryDate ? new Date(row.deliveryDate).toLocaleDateString() : ''
        };${row.id_mercury ? row.id_mercury : ''};${row.company.address.street} ${row.company.address.city} ${
          row.company.address.postalCode
        } ${this.$translate(
          row.company.address.country
        )};${materialprodstring};${materialaccstring};${creationDate};${creationUsername};${this.getDateStatus(
          row.history,
          'invord',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'invord', row.creationDate)};${this.getDateStatus(
          row.history,
          'sendord',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'sendord', row.creationDate)};${this.getDateStatus(
          row.history,
          'proc_order',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'proc_order', row.creationDate)};${this.getDateStatus(
          row.history,
          'waitord',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'waitord', row.creationDate)};${this.getDateStatus(
          row.history,
          'workord',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'workord', row.creationDate)};${this.getDateStatus(
          row.history,
          'endord',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'endord', row.creationDate)};${this.getDateStatus(
          row.history,
          'courier',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'courier', row.creationDate)};${this.getDateStatus(
          row.history,
          'processed',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'processed', row.creationDate)};${this.getDateStatus(
          row.history,
          'closed',
          row.creationDate
        )};${this.getUsernameStatus(row.history, 'closed', row.creationDate)};${claimString}\n`
      })
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      let filename = ''
      if (checkedRows.length == 1) {
        filename = checkedRows[0].primaryCode
        filename += '_'
        if (checkedRows[0].patient.alias) {
          filename += checkedRows[0].patient.alias
        } else {
          filename += checkedRows[0].patient.name + '_' + checkedRows[0].patient.surname
        }
        filename += '_'
        filename += new Date().toLocaleDateString()
        filename += '.csv'
      } else {
        filename = this.$options.filters.capitalize(this.$translate('list'))
        filename += '_'
        filename += this.$store.getters.user.userInfo.name
        filename += this.$store.getters.user.userInfo.surname
        filename += '_'
        filename += new Date().toLocaleDateString()
        filename += '_'
        filename += new Date().getHours()
        filename += '_'
        filename += new Date().getMinutes()
        filename += '_'
        filename += new Date().getSeconds()
        filename += '.csv'
      }

      link.setAttribute('download', filename)

      document.body.appendChild(link)
      link.click()
    },
    getCSVModelName(row) {
      const nameFor = mod => {
        if (!mod) return ''
        if (mod.name) return mod.name
        return mod.custom ? this.$translate('custom_model') : ''
      }
      if (row.module !== 'insole') return nameFor(row.mod)
      const sideName = side => {
        const mod = row[`mod_${side}`]
        return nameFor(mod && Object.keys(mod).length !== 0 ? mod : row.mod)
      }
      if (row.pair === 'left') return sideName('sx')
      if (row.pair === 'right') return sideName('dx')
      const sx = sideName('sx')
      const dx = sideName('dx')
      return sx === dx ? sx : `SX: ${sx} - DX: ${dx}`
    },
    getUsernameStatus(history, status, creationDate) {
      let event = history ? history.find(ev => ev.newStatus == status && ev.date > creationDate) : undefined
      let username = event ? event.technician : ''
      return username
    },
    getDateStatus(history, status, creationDate) {
      let event = history ? history.find(ev => ev.newStatus == status && ev.date > creationDate) : undefined
      let date = event ? new Date(event.date).toLocaleDateString() : ''
      return date
      //let date = ''
      //if (history && history.find(el => el.newStatus == status) != undefined) {
      //  date = new Date(
      //      history.find(el => el.newStatus == status).date
      //    ).toLocaleDateString();
      //}
      //return date
    },
    getCSVString(history, status) {
      let csvString = ''
      if (history && history.find(el => el.newStatus == status) != undefined) {
        csvString =
          history.find(el => el.newStatus == status).technician +
          ' ' +
          new Date(history.find(el => el.newStatus == status).date).toLocaleDateString()
      }
      return csvString
    },
    exportPdfTable() {
      let data = []
      this.tableOptions.checkedRows.forEach(row => {
        let newRow = {}
        newRow[this.$translate('client_code')] = row.company.mercurio_id
        newRow[this.$options.filters.capitalize(this.$translate('customer'))] = row.company.name
        newRow[this.$translate('date')] = new Date(row.send_date).toLocaleDateString()
        newRow[this.$translate('orderType')] = this.$translate(row.orderType)
        newRow[this.$translate('orderTypetext')] = this.$translate(row.orderTypeMain)
        newRow[this.$translate('orderTypeVariant')] = this.$translate(row.orderTypeVariant)
        newRow[this.$options.filters.capitalize(this.$translate('patient'))] = row.patient.alias
          ? row.patient.alias
          : row.patient.name + ' ' + row.patient.surname
        newRow[this.$translate('primaryCode')] = row.primaryCode ? row.primaryCode : ''
        newRow[this.$translate('secondaryCode')] = row.secondaryCode ? row.secondaryCode : ''
        newRow[this.$options.filters.capitalize(this.$translate('prec_pair'))] = row.prec_pair ? row.prec_pair : ''
        newRow[this.$translate('track_numbe')] = row.track_number ? row.track_number : ''
        newRow[this.$options.filters.capitalize(this.$translate('id_mercury'))] = row.id_mercury ? row.id_mercury : ''
        data.push(Object.assign({}, newRow))
      })

      let keys = [
        { name: this.$translate('client_code'), width: 60 },
        {
          name: this.$options.filters.capitalize(this.$translate('customer')),
          width: 100,
        },
        { name: this.$translate('date'), width: 40 },
        { name: this.$translate('orderType'), width: 55 },
        { name: this.$translate('orderTypetext'), width: 70 },
        { name: this.$translate('orderTypeVariant'), width: 75 },
        {
          name: this.$options.filters.capitalize(this.$translate('patient')),
          width: 70,
        },
        { name: this.$translate('primaryCode'), width: 90 },
        { name: this.$translate('secondaryCode'), width: 90 },
        {
          name: this.$options.filters.capitalize(this.$translate('prec_pair')),
          width: 70,
        },
        { name: this.$translate('track_numbe'), width: 60 },
        {
          name: this.$options.filters.capitalize(this.$translate('id_mercury')),
          width: 60,
        },
      ]

      var headers = []
      for (var i = 0; i < keys.length; i += 1) {
        headers.push({
          id: keys[i].name,
          name: keys[i].name,
          prompt: keys[i].name,
          align: 'center',
          width: keys[i].width,
          padding: 0,
        })
      }

      var doc = new jsPDF('l', 'px', 'a4')
      doc.table(1, 1, data, headers, { padding: 0, fontSize: 6 })

      doc.save(
        `Lista${this.$store.getters.user.userInfo.name}${
          this.$store.getters.user.userInfo.surname
        }${new Date().toLocaleDateString()}.pdf`
      )
    },
    checkMaterialArray(materials) {
      if (materials && materials.length && materials.length > 0) {
        materials.forEach(material => {
          if (!material.name) {
            //console.log('REGOLA 0.1')
            return false
          } else if (material.qty < 1) {
            //console.log('REGOLA 0.2')
            return false
          }
        })
      }
      return true
    },
    R1(order) {
      // Il campo riferimento ordine deve essere sempre presente
      return !!order.primaryCode
    },
    R2(order) {
      // Il tipo di calzatura deve essere sempre selezionata
      return !!order.shoeType
    },
    R3(order) {
      // Il tipo di catalogo deve essere sempre selezionato
      return !!order.catalogType
    },
    R4(order) {
      // Il tipo di ordine deve essere sempre selezionato.
      // Devono essere selezionate anche tutte le varianti se presenti.
      const company = order.company
      const availableOrderType = this.$availableOrderType[order.module]
      const { bdictionary } = this.$moduleConfiguration[order.module]
      const orderTypeDictionary = availableOrderType.find(types => types.key === company[bdictionary])
      // Check catalog existence
      if (!orderTypeDictionary || !orderTypeDictionary.variant) return false
      // Check order type selection
      if (!order.orderType) return false
      // Get choice
      if (order.module === 'tailored') {
        const orderType = orderTypeDictionary.variant.find(type => type.key === order.orderType)
        // Check order variant selection
        if (orderType && orderType.variant && !order.orderTypeMain) return false
        // Get variant choice
        const orderTypeMain = orderType.variant.find(typeMain => typeMain.key === order.orderTypeMain)
        // Check order variant variant selection
        if (orderTypeMain && orderTypeMain.variant && !order.orderTypeVariant) return false
        // Return true if are not present variant variant variant
        if (!orderTypeMain || !orderTypeMain.variant) return true
        // Get variant variant choice
        const orderTypeVariant = orderTypeMain.variant.find(typeVariant => typeVariant.key === order.orderTypeVariant)
        // Check order variant variant variant selection
        if (orderTypeVariant && orderTypeVariant.variant && !order.orderTypeSubVariant) return false
      }
      return true
    },
    R5(order) {
      // Il tipo di consegna deve essere sempre selezionato.
      // Devono essere selezionate anche tutte le varianti se presenti.
      const company = order.company
      const availableDeliveryType = this.$availableDeliveryType[order.module]
      const { ddictionary } = this.$moduleConfiguration[order.module]
      const deliveryDictionary = availableDeliveryType.find(deliveries => deliveries.key === company[ddictionary])
      // Check catalog existence
      if (!deliveryDictionary || !deliveryDictionary.variant) return false
      // Check delivery type selection
      if (!order.deliverySelected) return false
      // Get choiche object
      const deliveryType = deliveryDictionary.variant.find(type => type.key === order.deliverySelected)
      // Check variant selection
      if (deliveryType && deliveryType.variant && !order.deliverySelectedSub) return false
      return true
    },
    R6(order) {
      // Un modello deve essere sempre selezionato
      // La variante custom è equiparata ad un qualsiasi altro modello
      if (order.mod.catalogchoose) return false
      return true
    },
    R7(order) {
      // Il materiale relativo al primo pellame (comprensivo di variante) deve essere selezionato
      // Obbligatorio per tutti i tipi di consegna
      // Regola da escludere se da catalogo DUNA
      if (order.mod.custom && order.mod.from_duna_catalog) return true
      if (!order.mod.pell1mat) return false
      if (!order.mod.pell1var) return false
      return true
    },
    R7F(order) {
      // Il materiale relativo alla fodera deve essere selezionato
      if (!order.mod.fodantmat) return false
      if (!order.mod.fodantvar) return false
      if (!order.mod.fodposmat) return false
      if (!order.mod.fodposvar) return false
      return true
    },
    R8(order) {
      // Il materiale relativo alla fodera anteriore (comprensiva di variante) deve essere selezionato
      // Il materiale relativo alla fodera potersiore (comprensiva di variante) deve essere selezionato
      // Obbligatorio per calzature finite, calzature in prova e solo tomaie
      // Regola da escludere se da catalogo DUNA
      if (order.mod.custom && order.mod.from_duna_catalog) return true
      if (order.deliverySelected === 'testshoes') return true
      if (order.deliverySelected === 'onlyforme') return true
      if (!order.mod.fodantmat) return false
      if (!order.mod.fodantvar) return false
      if (!order.mod.fodposmat) return false
      if (!order.mod.fodposvar) return false
      return true
    },
    R8F(order) {
      // L'allacciatura deve essere selezionato
      if (!order.mod.allacciatura) return false
      return true
    },
    R9(order) {
      // Almeno un tipo di allacciatura (comprensiva di variante) deve essere selezionato
      // Obbligatoria per tutti i tipi di consegna
      // Regola da escludere se da catalogo DUNA
      if (order.mod.custom && order.mod.from_duna_catalog) return true
      if (order.mod.allacci.length < 1) return false
      const selection = order.mod.allacci[0].allprim
      if (!selection) return false
      const variants = this.$allacciatura.find(closing => closing.key === selection).variant
      if (variants.length > 0 && !order.mod.allacci[0].allvar) return false
      return true
    },
    R9F(order) {
      // La suola deve essere selezionato
      if (!order.mod.sole) return false
      return true
    },
    R10(order) {
      // Materiali battistrada e tacco o zeppa (comprensivi di variante) devono essere selezionati
      // Obbligatori per calzature finite e calzature in prova con materiali
      // Intersuola facoltativa: se scelto un materiale serve la variante
      // Regola da escludere se da catalogo DUNA
      if (order.mod.custom && order.mod.from_duna_catalog) return true
      if (order.mod.battmat && !order.mod.battvar) return false
      if (order.mod.tacczepp && !order.mod.tacczeppvar) return false
      if (order.mod.intemat && order.mod.intemat != 'Noone' && !order.mod.intevar) return false
      if (order.deliverySelected !== 'devshoeended' && order.deliverySelectedSub !== 'trymat') return true
      if (!order.mod.battmat) return false
      if (!order.mod.battvar) return false
      if (!order.mod.tacczepp) return false
      if (!order.mod.tacczeppvar) return false
      if (order.mod.intemat && order.mod.intemat != 'Noone' && !order.mod.intevar) return false
      return true
    },
    R11(order) {
      // Almeno la foggia (comprensiva di variante) deve essere selezionata
      // Obbligatoria solo per calzature finite
      // Regola da escludere se da catalogo DUNA
      if (order.mod.custom && order.mod.from_duna_catalog) return true
      if (order.mod.tacc && !order.mod.taccvar) return false
      if (order.deliverySelected !== 'devshoeended') return true
      if (!order.mod.tacc) return false
      if (!order.mod.taccvar) return false
      return true
    },
    R12(order) {
      // Tipo, montaggio e materiale (comprensivo di variante) del guardolo devono essere selezionate
      // Obbligatori per calzature finite (e varianti) e calzature in prova con materiali
      // Regola da escludere se da catalogo DUNA
      if (order.mod.custom && order.mod.from_duna_catalog) return true
      if (!this.isRifinituraComplete(order.mod)) return false
      if (order.deliverySelected !== 'devshoeended' && order.deliverySelectedSub !== 'trymat') return true
      if (!order.mod.riftype) return false
      if (order.mod.riftype == 'rifinitura0') {
        if (!order.mod.mountag) return false
        if (!order.mod.guardmat) return false
        if (!order.mod.guardvar) return false
      }
      if (order.mod.riftype == 'rifinitura1') {
        if (!order.mod.mountag) return false
        if (!order.mod.fascmat) return false
        if (!order.mod.fascvar) return false
      }
      return true
    },
    isRifinituraComplete(mod) {
      if (mod.riftype == 'rifinitura0') return !!(mod.mountag && mod.guardmat && mod.guardvar)
      if (mod.riftype == 'rifinitura1') return !!(mod.mountag && mod.fascmat && mod.fascvar)
      return true
    },
    R13_2(order) {
      // Se viene abilitata l'opzione forature scegliere per forza passante/non passante
      if (order.mod.puncture && !order.mod.passing) return false
      return true
    },
    R13_3(order) {
      // Se l'utente richiede un secondo tipo di allacciatura questo deve essere compilato
      if (order.mod.allacci.length < 2) return true
      for (const a of order.mod.allacci) {
        const selection = a.allprim
        if (!selection) return false
        const variants = this.$allacciatura.find(closing => closing.key === selection).variant
        if (variants.length > 0 && !a.allvar) return false
      }
      return true
    },
    R13F(order) {
      if (
        (order.footmeasurements.left && !order.footmeasurements.left.size) ||
        (order.footmeasurements.right && !order.footmeasurements.right.size)
      ) {
        return false
      }
      return true
    },
    R14(order) {
      // Se tipo d'ordine è Misure (tutte le sottovarianti) o Misure Digitali (tutte sottovarianti tranne progetto forma)
      // Sono obbligatorie le seguenti misure:
      // Lunghezza - Circonferenza metatarsi - Circonferenza collo - Altezza tacco (Piede) - Passata
      // R16: Nel caso in cui tipo d'ordine sia gesso o forme la regola non si applica - MI SEMBRA UNA RIPETIZIONE
      if (!this.R14_Dx(order)) return false
      if (!this.R14_Sx(order)) return false
      return true
    },
    R14_Dx(order) {
      if (
        order.orderTypeMain !== 'measurements' &&
        (order.orderTypeMain !== 'digitalMeasurements' || order.orderTypeVariant === 'formproj')
      )
        return true
      const measurements = order.footmeasurements
      if (measurements === 'sx_c_pa') return true
      if (!measurements.foot_long_dx) return false
      if (!measurements.circ_meta_dx) return false
      if (!measurements.circ_neck_dx) return false
      if (measurements.high_heel_dx == null || measurements.high_heel_dx === '') return false
      return true
    },
    R14_Sx(order) {
      if (
        order.orderTypeMain !== 'measurements' &&
        (order.orderTypeMain !== 'digitalMeasurements' || order.orderTypeVariant === 'formproj')
      )
        return true
      const measurements = order.footmeasurements
      if (measurements === 'dx_c_pa') return true
      if (!measurements.foot_long_sx) return false
      if (!measurements.circ_meta_sx) return false
      if (!measurements.circ_neck_sx) return false
      if (measurements.high_heel_sx == null || measurements.high_heel_sx === '') return false
      return true
    },
    R15(order) {
      // Se tipo d'ordine è Misure (tutte le sottovarianti) o Misure Digitali (tutte sottovarianti tranne progetto forma)
      // Se si tratta di una calzatura alta sono obbligatorie le seguenti misure:
      // Circonferenza gamba - Altezza gamba
      // R16: Nel caso in cui tipo d'ordine sia gesso o forme la regola non si applica - MI SEMBRA UNA RIPETIZIONE
      if (!this.R15_Dx(order)) return false
      if (!this.R15_Sx(order)) return false
      return true
    },
    R15_Dx(order) {
      if (order.shoeType !== 'high') return true
      if (
        order.orderTypeMain !== 'measurements' &&
        (order.typeMain !== 'digitalMeasurements' || order.orderTypeVariant === 'formproj')
      )
        return true
      const measurements = order.footmeasurements
      if (measurements.c_pair === 'sx_c_pa') return true
      if (!measurements.circ_leg_dx) return false
      if (!measurements.high_leg_dx) return false
      return true
    },
    R15_Sx(order) {
      if (order.shoeType !== 'high') return true
      if (
        order.orderTypeMain !== 'measurements' &&
        (order.typeMain !== 'digitalMeasurements' || order.orderTypeVariant === 'formproj')
      )
        return true
      const measurements = order.footmeasurements
      if (measurements.c_pair === 'dx_c_pa') return true
      if (!measurements.circ_leg_sx) return false
      if (!measurements.high_leg_sx) return false
      return true
    },
    R16F(order) {
      const m = order.footmeasurements
      if (!m || !m.left || !m.left.fit_code) return false
      if (!m.right || !m.right.fit_code) return false
      const shapes = order.mod && order.mod.sole && order.mod.sole.shapes ? order.mod.sole.shapes : []
      const codes = shapes.filter(shape => shape.type === order.shoeType).map(shape => shape.fit_code)
      if (!codes.includes(m.left.fit_code) || !codes.includes(m.right.fit_code)) return false
      return true
    },
    R16M(order) {
      const m = order.footmeasurements
      if (!m || !m.left || !m.right) return false
      const config = this.$moduleConfiguration[order.module]
      const headers =
        order.shoeType === 'high' ? this.$shapeTableHeadersHigh[order.module] : this.$shapeTableHeadersLow[order.module]
      const required = headers.filter(header => header !== 'size' && config.isMeasurementRequired(header))
      for (const key of required) {
        if (!m.left[key]) return false
        if (!m.right[key]) return false
      }
      return true
    },
    R17(order) {
      if (!this.R17_Dx(order)) return false
      if (!this.R17_Sx(order)) return false
      return true
    },
    R17_Dx(order) {
      if (order.plan_realization !== 'reali_duna') return true
      if (order.isDunaInsoleDisabledDx) return true
      const measurements = order.footmeasurements
      if (!measurements.thick_cen_heel_dx) return false
      if (!measurements.thick_pla_dx) return false
      if (!measurements.thick_poi_dx) return false
      return true
    },
    R17_Sx(order) {
      if (order.plan_realization !== 'reali_duna') return true
      if (order.isDunaInsoleDisabledSx) return true
      const measurements = order.footmeasurements
      if (!measurements.thick_cen_heel_sx) return false
      if (!measurements.thick_pla_sx) return false
      if (!measurements.thick_poi_sx) return false
      return true
    },
    //R18 è stato eliminato
    R18F_Sx(order) {
      if (order.typecontr_sx !== 'Noone') {
        if (!order.typecontr_sx) return false
        if (!order.tipocontr_sx) return false
        if (!order.tipocontr_var_sx) return false
      }
      return true
    },
    R18F_Dx(order) {
      if (order.typecontr_dx !== 'Noone') {
        if (!order.typecontr_dx) return false
        if (!order.tipocontr_dx) return false
        if (!order.tipocontr_var_dx) return false
      }
      return true
    },
    R19(order) {
      // Deve essere impostata la taglia in punti francesi della calzature
      // Obbligatoria per i tipi di ordine misure, misure digitali e gessi
      if (!this.R19_Dx(order)) return false
      if (!this.R19_Sx(order)) return false
      return true
    },
    R19_Dx(order) {
      if (!['measurements', 'digitalMeasurements', 'mold'].includes(order.orderTypeMain)) return true
      const measurements = order.footmeasurements
      if (measurements.c_pair === 'sx_c_pa') return true
      if (!measurements.measure_dx) return false
      return true
    },
    R19_Sx(order) {
      if (!['measurements', 'digitalMeasurements', 'mold'].includes(order.orderTypeMain)) return true
      const measurements = order.footmeasurements
      if (measurements.c_pair === 'dx_c_pa') return true
      if (!measurements.measure_sx) return false
      return true
    },
    R20(order) {
      // Per tutti i tipi di ordine deve essere impostata l'altezza del tacco/zeppa
      // Se il tipo di fondo è zeppa deambulante ed è stato impostato lo spessore a centro tacco fa eccezione
      if (!this.R20_Dx(order)) return false
      if (!this.R20_Sx(order)) return false
      return true
    },
    R20_Dx(order) {
      if (order.footmeasurements === 'sx_c_pa') return true
      if (order.mod.tacc === 'foggiafondo2' && order.footmeasurements.ext_high_heel_dx) return true
      if (!order.footmeasurements.high_heel_zep_dx) return false
      return true
    },
    R20_Sx(order) {
      if (order.footmeasurements === 'dx_c_pa') return true
      if (order.mod.tacc === 'foggiafondo2' && order.footmeasurements.ext_high_heel_sx) return true
      if (!order.footmeasurements.high_heel_zep_sx) return false
      return true
    },
    // R21: Nel caso in cui l'utente abbia selezionato nel pannello selezione forma solo destra o solo sinistra
    // le regole R14->R20 si applicano solo al lato interessato
    R22(order) {
      // Se  l'utente ha selezionato misure digitali o file 3D, almeno un file deve essere allegato in allegati>Duna o allegati>scansione
      // L'allegato scansione è obbligatorio per tipo di ordine forme > forme e plantari > file 3D
      if (!this.R22_Dx(order)) return false
      if (!this.R22_Sx(order)) return false
      return true
    },
    R22_Dx(order) {
      const attachments = order.attachment
      if (
        order.orderTypeMain === 'last' &&
        order.orderTypeVariant === 'formplusplant' &&
        order.orderTypeSubVariant === 'file3D' &&
        !attachments.scan_no_duna_dx
      )
        return false
      if (order.orderTypeMain !== 'digitalMeasurements') return true
      if (order.orderTypeVariant === 'formproj') {
        if (!attachments.scan_no_duna_dx) return false
      } else {
        if (attachments.scan_fms_dx) return true
        if (attachments.scan_pln_dx) return true
        if (attachments.scan_stl_dx) return true
        if (attachments.scan_no_duna_dx) return true
        return false
      }
      return true
    },
    R22_Sx(order) {
      const attachments = order.attachment
      if (
        order.orderTypeMain === 'last' &&
        order.orderTypeVariant === 'formplusplant' &&
        order.orderTypeSubVariant === 'file3D' &&
        !attachments.scan_no_duna_sx
      )
        return false
      if (order.orderTypeMain !== 'digitalMeasurements') return true
      if (order.orderTypeVariant === 'formproj') {
        if (!attachments.scan_no_duna_sx) return false
      } else {
        if (attachments.scan_fms_sx) return true
        if (attachments.scan_pln_sx) return true
        if (attachments.scan_stl_sx) return true
        if (attachments.scan_no_duna_sx) return true
        return false
      }
      return true
    },
    R23(order) {
      // Tipo e materiale del contrafforte devono essere selezionati
      // A meno che non venga scelto il tipo di contrafforte NESSUNO
      // RC17 A meno che il tipo di ordine sia solo tomaia
      if (!this.R23_Dx(order)) return false
      if (!this.R23_Sx(order)) return false
      return true
    },
    R23_Dx(order) {
      if (order.deliverySelected === 'onlytom') return true
      if (order.typecontr_dx !== 'Noone') {
        if (!order.typecontr_dx) return false
        if (!order.tipocontr_dx) return false
        if (!order.tipocontr_var_dx) return false
      }
      return true
    },
    R23_Sx(order) {
      if (order.deliverySelected === 'onlytom') return true
      if (order.typecontr_sx !== 'Noone') {
        if (!order.typecontr_sx) return false
        if (!order.tipocontr_sx) return false
        if (!order.tipocontr_var_sx) return false
      }
      return true
    },
    R24(order) {
      // Materiale e variante del sottopiede devo essere selezionati
      // RC17 A meno che il tipo di ordine sia solo tomaia
      if (!this.R24_Dx(order)) return false
      if (!this.R24_Sx(order)) return false
      return true
    },
    R24_Dx(order) {
      if (order.deliverySelected === 'onlytom') return true
      if (!order.tiposott_dx) return false
      if (!order.tiposott_var_dx) return false
      return true
    },
    R24_Sx(order) {
      if (order.deliverySelected === 'onlytom') return true
      if (!order.tiposott_sx) return false
      if (!order.tiposott_var_sx) return false
      return true
    },
    R25(order) {
      // Tipo e matriale del puntale devono essere selezionati
      // RC17 A meno che il tipo di ordine sia solo tomaia
      // A meno che non venga scelto il tipo puntale NESSUNO
      if (!this.R25_Dx(order)) return false
      if (!this.R25_Sx(order)) return false
      return true
    },
    R25_Dx(order) {
      if (order.deliverySelected === 'onlytom') return true
      if (order.tipopunt_dx !== 'tipopunt1') {
        if (!order.tipopunt_mat_dx) return false
        if (!order.tipopunt_mat_var_dx) return false
      }
      return true
    },
    R25_Sx(order) {
      if (order.deliverySelected === 'onlytom') return true
      if (order.tipopunt_sx !== 'tipopunt1') {
        if (!order.tipopunt_mat_sx) return false
        if (!order.tipopunt_mat_var_sx) return false
      }
      return true
    },
    R26(order) {
      // L'altezza posteriore della tomaia è obbligatoria per calzatura alta con tipo di consegna solo tomaie
      if (!this.R26_Dx(order)) return false
      if (!this.R26_Sx(order)) return false
      return true
    },
    R26_Dx(order) {
      if (order.shoeType !== 'high') return true
      if (order.deliverySelected !== 'onlytom') return true
      const measurements = order.footmeasurements
      if (measurements.c_pair === 'sx_c_pa') return true
      if (!measurements.high_post_tom_dx) return false
      return true
    },
    R26_Sx(order) {
      if (order.shoeType !== 'high') return true
      if (order.deliverySelected !== 'onlytom') return true
      const measurements = order.footmeasurements
      if (measurements.c_pair === 'dx_c_pa') return true
      if (!measurements.high_post_tom_sx) return false
      return true
    },
    R27(order) {
      // L'allegato grafico è obbligatorio per tipo di ordine misure
      if (!this.R27_Dx(order)) return false
      if (!this.R27_Sx(order)) return false
      return true
    },
    R27_Dx(order) {
      if (order.orderTypeMain !== 'measurements') return true
      if (!order.attachment.grap_dx) return false
      return true
    },
    R27_Sx(order) {
      if (order.orderTypeMain !== 'measurements') return true
      if (!order.attachment.grap_sx) return false
      return true
    },
    RC9(order) {
      if (!this.RC9_Dx(order)) return false
      if (!this.RC9_Sx(order)) return false
      return true
    },
    RC9_Dx(order) {
      if (!order.mod.suola_finn_dx) return true
      if (!order.mod.smuss_post_dx) return false
      return true
    },
    RC9_Sx(order) {
      if (!order.mod.suola_finn_sx) return true
      if (!order.mod.smuss_post_sx) return false
      return true
    },
    CheckInsole(order) {
      if (order.plan_realization === 'reali_duna') {
        if (!order.isDunaInsoleDisabledDx && !this.CheckInsole_Dx(order)) return false
        if (!order.isDunaInsoleDisabledSx && !this.CheckInsole_Sx(order)) return false
      }
      return true
    },
    CheckInsole_Dx(order) {
      if (order.plan_realization !== 'reali_duna') return true
      if (order.isDunaInsoleDisabledDx) return true
      if (order.plantar_type_dx === 'Noone') return false
      if (!order.footmeasurements.base_mat_dx) return false
      if (!order.footmeasurements.base_matvar_dx) return false
      return true
    },
    CheckInsole_Sx(order) {
      if (order.plan_realization !== 'reali_duna') return true
      if (order.isDunaInsoleDisabledSx) return true
      if (order.plantar_type_sx === 'Noone') return false
      if (!order.footmeasurements.base_mat_sx) return false
      if (!order.footmeasurements.base_matvar_sx) return false
      return true
    },
    checkGeneralInfo(order) {
      if (!this.R1(order)) return false // questo
      if (!this.R2(order)) return false
      if (!this.R3(order)) return false
      return true
    },
    checkOrderType(order) {
      if (!this.R4(order)) return false // questo
      if (!this.R5(order)) return false
      return true
    },
    checkModel(order) {
      if (order.module === 'tailored' || !order.module) {
        if (!this.R6(order)) return false
        if (!this.R7(order)) return false
        if (!this.R8(order)) return false
        if (!this.R9(order)) return false
        if (!this.R10(order)) return false
        if (!this.R11(order)) return false
        if (!this.R12(order)) return false
        if (!this.R13_2(order)) return false
        if (!this.R13_3(order)) return false
      }
      if (order.module === 'fits') {
        if (!this.R6(order)) return false
        if (!this.R7F(order)) return false
        if (!this.R8F(order)) return false
        if (!this.R9F(order)) return false
      }
      if (order.module === 'modular') {
        if (!this.R6(order)) return false
        if (!this.R9F(order)) return false
      }
      return true
    },
    checkMeasurements(order) {
      //console.log('R14')
      if (order.module === 'tailored' || !order.module) {
        if (!this.R14(order)) return false
        if (!this.R15(order)) return false
        if (!this.R17(order)) return false
        if (!this.R19(order)) return false
        if (!this.R20(order)) return false
        if (!this.R22(order)) return false
        if (!this.R26(order)) return false
        if (!this.R27(order)) return false
      } else {
        if (!this.R13F(order) || !this.R16F(order)) {
          return false
        }
        if (order.module === 'modular' && !this.R16M(order)) {
          return false
        }
      }
      return true
    },
    checkMeasurements_Dx(order) {
      if (!this.R14_Dx(order)) return false
      if (!this.R15_Dx(order)) return false
      if (!this.R17_Dx(order)) return false
      if (!this.R19_Dx(order)) return false
      if (!this.R20_Dx(order)) return false
      if (!this.R22_Dx(order)) return false
      if (!this.R26_Dx(order)) return false
      if (!this.R27_Dx(order)) return false
      return true
    },
    checkMeasurements_Sx(order) {
      if (!this.R14_Sx(order)) return false
      if (!this.R15_Sx(order)) return false
      if (!this.R17_Sx(order)) return false
      if (!this.R19_Sx(order)) return false
      if (!this.R20_Sx(order)) return false
      if (!this.R22_Sx(order)) return false
      if (!this.R26_Sx(order)) return false
      if (!this.R27_Sx(order)) return false
      return true
    },
    checkDetails(order) {
      if (order.module === 'tailored' || !order.module) {
        if (!this.R23(order)) return false
        if (!this.R24(order)) return false
        if (!this.R25(order)) return false
      } else if (order.module === 'fits') {
        if (!this.R18F_Sx(order) || !this.R18F_Dx(order)) {
          return false
        }
      }
      return true
    },
    checkDetails_Dx(order) {
      if (!this.R23_Dx(order)) return false
      if (!this.R24_Dx(order)) return false
      if (!this.R25_Dx(order)) return false
      return true
    },
    checkDetails_Sx(order) {
      if (!this.R23_Sx(order)) return false
      if (!this.R24_Sx(order)) return false
      if (!this.R25_Sx(order)) return false
      return true
    },
    checkSend(order) {
      //5.1 FWW - REV.5
      if (order.module === 'insole') return this.checkSendInsole(order)
      if (order.pair === 'both' || order.module === 'fits' || order.module === 'modular')
        return this.checkSend_Both(order)
      if (order.pair === 'left') return this.checkSend_Sx(order)
      if (order.pair === 'right') return this.checkSend_Dx(order)
      return true
    },
    checkSendInsole(order) {
      if (!order.primaryCode) return false
      if (!order.orderType || !order.orderTypeMain) return false
      if (['negative', 'fenofoam', 'positiveormodified'].includes(order.orderTypeMain) && !order.orderTypeMainRifMat) {
        return false
      }
      if (!order.deliverySelected || !order.deliverySelectedSub) return false
      const fm = order.footmeasurements ? order.footmeasurements : {}
      if (fm.size == null || fm.size === '') return false
      const sides = order.pair === 'left' ? ['sx'] : order.pair === 'right' ? ['dx'] : ['sx', 'dx']
      for (const side of sides) {
        let mod = side === 'sx' ? order.mod_sx : order.mod_dx
        if (!mod || Object.keys(mod).length === 0) mod = order.mod
        if (!mod || !mod.image) return false
        if (!mod.dime) return false
        if (!mod.insoleBaseMat || !mod.insoleBaseVar) return false
        if (mod.insoleCoverMat && !mod.insoleCoverVar) return false
        if (mod.insoleFillMat && !mod.insoleFillVar) return false
        for (const key of ['ball_height', 'fings_height', 'heel_height', 'sup_col_med', 'avvolgenza_mediale']) {
          const value = fm[`${key}_${side}`]
          if (value == null || value === '') return false
        }
      }
      return true
    },
    checkSend_Both(order) {
      if (!this.checkGeneralInfo(order)) return false
      if (!this.checkOrderType(order)) return false
      if (!this.checkModel(order)) return false
      if (!this.checkMeasurements(order)) return false
      if (!this.checkDetails(order)) return false
      if (order.module !== 'fits') {
        if (!this.RC9(order)) {
          return false
        }
        if (!this.CheckInsole(order)) {
          return false
        }
      }

      return true
    },
    checkSend_Dx(order) {
      if (!this.checkGeneralInfo(order)) return false
      if (!this.checkOrderType(order)) return false
      if (!this.checkModel(order)) return false
      if (!this.checkMeasurements_Dx(order)) return false
      if (!this.checkDetails_Dx(order)) return false
      if (!this.RC9_Dx(order)) return false
      if (!this.CheckInsole_Dx(order)) return false
      return true
    },
    checkSend_Sx(order) {
      if (!this.checkGeneralInfo(order)) return false
      //console.log('General Info Passed')
      if (!this.checkOrderType(order)) return false
      //console.log('Order Type Passed')
      if (!this.checkModel(order)) return false
      //console.log('Model Passed')
      if (!this.checkMeasurements_Sx(order)) return false
      //console.log('Measurements Passed')
      if (!this.checkDetails_Sx(order)) return false
      //console.log('Details Passed')
      if (!this.RC9_Sx(order)) return false
      //console.log('R9 Passed')
      if (!this.CheckInsole_Sx(order)) return false
      //console.log('Insole Passed')
      return true
    },
    isSendable(ordertocheck) {
      //5.1 FWW REGOLE MINIME
      //Materiali aggiuntivi
      //console.log('inizio check')
      if (!this.checkMaterialArray(ordertocheck.materialprod)) return false
      //console.log('check materiali produzioni fatto')
      if (!this.checkMaterialArray(ordertocheck.materialacc)) return false
      //console.log('check materiali accessori fatto')
      //var checkmaterialboolean = false;
      //if (
      //ordertocheck.materialprod != null &&
      //ordertocheck.materialprod != undefined &&
      //ordertocheck.materialprod.length != 0 &&
      //Object.keys(ordertocheck.materialprod).length != 0
      //) {
      //ordertocheck.materialprod.forEach(material => {
      //if (material.name == undefined || material.name == "") {
      ////console.log("Produzione materiale");
      //checkmaterialboolean = true;
      //}
      //if (material.qty <= 0) {
      //checkmaterialboolean = true
      //}
      //});
      //}
      //if (
      //ordertocheck.materialacc != null &&
      //ordertocheck.materialacc != undefined &&
      //ordertocheck.materialacc.length != 0 &&
      //Object.keys(ordertocheck.materialacc).length != 0
      //) {
      //ordertocheck.materialacc.forEach(material => {
      //if (material.name == undefined || material.name == "") {
      ////console.log("Progettazione materiale");
      //checkmaterialboolean = true;
      //}
      //if (material.qty <= 0) {
      //checkmaterialboolean = true
      //}
      //});
      //}
      //if (checkmaterialboolean) {
      //return false;
      //}
      //INFO GENERALE
      //R1
      if (ordertocheck.primaryCode == null) {
        //console.log("R1");
        return false
      }
      //R2
      if (ordertocheck.shoeType == null) {
        //console.log("R2");
        return false
      }
      //R3
      if (ordertocheck.catalogType == null) {
        //console.log("R3");
        return false
      }
      //R4
      let dictionaryB = {}
      dictionaryB = this.$availableOrderType[this.order.module].find(
        temp => temp.key === ordertocheck.company.bdictionary
      )
      //Preregole
      if (dictionaryB === undefined) {
        //console.log("missing dictionary B");
        return false
      }
      dictionaryB = dictionaryB.variant
      if (dictionaryB === undefined) {
        //console.log("missing dictionary B");
        return false
      }
      //orderType
      if (ordertocheck.orderType == null) {
        //console.log("missing orderType");
        return false
      }
      //Eventuale sottoscelta
      let orderTypeObject = dictionaryB.find(orderType => orderType.key === ordertocheck.orderType)
      if (orderTypeObject && orderTypeObject.variant && !ordertocheck.orderTypeMain) {
        //console.log("missing orderTypeMain");
        return false
      }
      //Eventuale sottosottoscelta
      let orderTypeMainObject
      if (orderTypeObject && orderTypeObject.variant) {
        orderTypeMainObject = orderTypeObject.variant.find(
          orderTypeMain => orderTypeMain.key === ordertocheck.orderTypeMain
        )
        if (orderTypeMainObject && orderTypeMainObject.variant && !ordertocheck.orderTypeVariant) {
          //console.log("missing orderTypeVariant");
          return false
        }
      }
      //Eventuale sottosottoscelta
      if (orderTypeMainObject && orderTypeMainObject.variant) {
        let orderTypeVariantObject = orderTypeMainObject.variant.find(
          orderTypeVariant => orderTypeVariant.key === ordertocheck.orderTypeVariant
        )
        if (orderTypeVariantObject && orderTypeVariantObject.variant && !ordertocheck.orderTypeSubVariant) {
          //console.log("missing orderTypeSubVariant");
          return false
        }
      }

      //if (
      //  dictionaryB.find(temp => temp.key === ordertocheck.orderType) !=
      //    undefined &&
      //  dictionaryB.find(temp => temp.key === ordertocheck.orderType).variant &&
      //  ordertocheck.orderTypeMain == null
      //) {
      //  return false;
      //}
      //Eventuale sottosottoscelta
      //if (
      //  dictionaryB
      //    .find(temp => temp.key === ordertocheck.orderType)
      //    .variant.find(temp => temp.key === ordertocheck.orderTypeMain) !=
      //    undefined &&
      //  dictionaryB
      //    .find(temp => temp.key === ordertocheck.orderType)
      //    .variant.find(temp => temp.key === ordertocheck.orderTypeMain)
      //    .variant &&
      //  ordertocheck.orderTypeVariant == null
      //) {
      //  return false;
      //}
      ////Eventuale sottosottosottoscelta
      //console.log(dictionaryB)
      //if (
      //  dictionaryB
      //    .find(temp => temp.key === ordertocheck.orderType)
      //    .variant.find(temp => temp.key === ordertocheck.orderTypeMain)
      //    .variant?.find(temp => temp.key === ordertocheck.orderTypeVariant) !=
      //    undefined &&
      //  dictionaryB
      //    .find(temp => temp.key === ordertocheck.orderType)
      //    .variant.find(temp => temp.key === ordertocheck.orderTypeMain)
      //    .variant?.find(temp => temp.key === ordertocheck.orderTypeVariant)
      //    .variant &&
      //  ordertocheck.orderTypeSubVariant == null
      //) {
      //  return false;
      //}
      //R5
      let dictionaryD = {}
      dictionaryD = this.$availableDeliveryType[this.order.module].find(
        temp => temp.key === ordertocheck.company.ddictionary
      )
      //Preregole
      if (dictionaryD == undefined) {
        return false
      }
      dictionaryD = dictionaryD.variant
      if (dictionaryD == undefined) {
        return false
      }
      //deliveredType
      if (ordertocheck.deliverySelected == null) {
        return false
      }
      //Eventuale sottoscelta
      if (
        dictionaryD.find(temp => temp.key === ordertocheck.deliverySelected) != undefined &&
        dictionaryD.find(temp => temp.key === ordertocheck.deliverySelected).variant &&
        ordertocheck.deliverySelectedSub == null
      ) {
        return false
      }
      //R6
      if (ordertocheck.mod.catalogchoose) {
        //console.log("R6");
        return false
      }

      //console.log('fatta regola 6')
      //REGOLE MODELLO
      //R13 -> Da R7 a R12 solo se non è modello custom
      if (!(ordertocheck.mod.custom && !ordertocheck.mod.from_duna_catalog)) {
        if (!ordertocheck.mod.color_bool) {
          //console.log('custom ' + ordertocheck.mod.custom)
          //console.log('catalog ' + ordertocheck.mod.from_duna_catalog)
          //R7 R8: materiale primo pellame e variante obbligatorio, fodera anteriore e fodera posteriore (meno se consegna è test shoes o solo forme)
          if (ordertocheck.deliverySelected !== 'testshoes' && ordertocheck.deliverySelected !== 'onlyforme') {
            if (!(ordertocheck.mod.custom && ordertocheck.mod.color_bool)) {
              if (!ordertocheck.mod.pell1mat || !ordertocheck.mod.pell1var) {
                //console.log('REGOLA 7')
                return false
              }
              if (
                !ordertocheck.mod.fodantmat ||
                !ordertocheck.mod.fodantvar ||
                !ordertocheck.mod.fodposmat ||
                !ordertocheck.mod.fodposvar
              ) {
                //console.log('REGOLA 8')
                return false
              }
            }
          }
          //R9 R10 R11 R12
          if (
            ordertocheck.deliverySelected !== 'testshoes' &&
            ordertocheck.deliverySelected !== 'onlyforme' &&
            ordertocheck.deliverySelectedSub !== 'onlytom' &&
            ordertocheck.deliverySelectedSub !== 'trymont'
          ) {
            if (ordertocheck.mod.allacci.length < 1) {
              //console.log('REGOLA 9.1')
              return false
            }
            if (!ordertocheck.mod.allacci[0].allprim) {
              //console.log('REGOLA 9.2')
              return false
            }
            let variants = this.$allacciatura.find(element => {
              return element.key == ordertocheck.mod.allacci[0].allprim
            }).variant
            if (variants.length > 0 && !ordertocheck.mod.allacci[0].allvar) {
              //console.log('REGOLA 9.3')
              return false
            }
            if (
              !ordertocheck.mod.battmat ||
              !ordertocheck.mod.battvar ||
              !ordertocheck.mod.tacczepp ||
              !ordertocheck.mod.tacczeppvar
            ) {
              //console.log('REGOLA 10')
              return false
            }
            if (!ordertocheck.mod.tacc || !ordertocheck.mod.taccvar) {
              //console.log('REGOLA 11')
              return false
            }
            if (!ordertocheck.mod.riftype) {
              //console.log('REGOLA 12.1')
              return false
            }
            if (ordertocheck.mod.riftype == 'rifinitura0') {
              if (!ordertocheck.mod.mountag || !ordertocheck.mod.guardmat || !ordertocheck.mod.guardvar) {
                //console.log('REGOLA 12.2')
                return false
              }
            }
            if (ordertocheck.mod.riftype == 'rifinitura1') {
              if (!ordertocheck.mod.mountag || !ordertocheck.mod.fascmat || !ordertocheck.mod.fascvar) {
                //console.log('REGOLA 12.3')
                return false
              }
            }
          }
        }
      }
      //console.log('fatta regola 12')
      //TODO 13 dopo custom model

      //MISURE
      //R21 distribuito nel R16-R20
      //R16
      if (
        (ordertocheck.orderTypeMain == 'measurements' || ordertocheck.orderTypeMain == 'digitalMeasurements') &&
        ordertocheck.orderTypeVariant != 'formproj'
      ) {
        //&& ordertocheck.orderTypeVariant != "card2" && ordertocheck.orderTypeVariant != "formproj") {
        //R14
        //const measurements = ordertocheck.footmeasurements
        //if (measurements.c_pair != "dx_c_pa") {
        //if (!measurements.foot_long_sx || !measurements.circ_meta_sx || !measurements.circ_neck_sx || !measurements.high_heel_sx || !measurements.circ_past_sx) {
        ////console.log("R14 sx")
        //return false
        //}
        //if (ordertocheck.shoeType == "high" && (!measurements.circ_leg_sx || !measurements.high_leg_sx)) {
        ////console.log("R15 sx")
        //return false
        //}
        //}
        //if (measurements.c_pair != "sx_c_pa") {
        //if (!measurements.foot_long_dx || !measurements.circ_meta_dx || !measurements.circ_neck_dx || !measurements.high_heel_dx || !measurements.circ_past_dx) {
        ////console.log("R14 dx")
        //return false
        //}
        //if (ordertocheck.shoeType == "high" && (!measurements.circ_leg_dx || !measurements.high_leg_dx)) {
        ////console.log("R15 dx")
        //return false
        //}
        //}
        if (
          (ordertocheck.footmeasurements.c_pair != 'dx_c_pa' &&
            (ordertocheck.footmeasurements.foot_long_sx == null || ordertocheck.footmeasurements.foot_long_sx == '')) ||
          (ordertocheck.footmeasurements.c_pair != 'sx_c_pa' &&
            (ordertocheck.footmeasurements.foot_long_dx == null || ordertocheck.footmeasurements.foot_long_dx == ''))
        ) {
          //if (ordertocheck.orderTypeVariant != "formproj") {
          //console.log("R14");
          return false
          //}
        }
        if (
          (ordertocheck.footmeasurements.c_pair != 'dx_c_pa' &&
            (ordertocheck.footmeasurements.circ_meta_sx == null || ordertocheck.footmeasurements.circ_meta_sx == '')) ||
          (ordertocheck.footmeasurements.c_pair != 'sx_c_pa' &&
            (ordertocheck.footmeasurements.circ_meta_dx == null || ordertocheck.footmeasurements.circ_meta_dx == ''))
        ) {
          //if (ordertocheck.orderTypeVariant != "formproj") {
          //console.log("R14");
          return false
          //}
        }
        if (
          (ordertocheck.footmeasurements.c_pair != 'dx_c_pa' &&
            (ordertocheck.footmeasurements.circ_neck_sx == null || ordertocheck.footmeasurements.circ_neck_sx == '')) ||
          (ordertocheck.footmeasurements.c_pair != 'sx_c_pa' &&
            (ordertocheck.footmeasurements.circ_neck_dx == null || ordertocheck.footmeasurements.circ_neck_dx == ''))
        ) {
          //console.log("R14");
          //if (ordertocheck.orderTypeVariant != "formproj") {
          return false
          //}
        }
        if (
          (ordertocheck.footmeasurements.c_pair != 'dx_c_pa' &&
            (ordertocheck.footmeasurements.high_heel_sx == null || ordertocheck.footmeasurements.high_heel_sx == '')) ||
          (ordertocheck.footmeasurements.c_pair != 'sx_c_pa' &&
            (ordertocheck.footmeasurements.high_heel_dx == null || ordertocheck.footmeasurements.high_heel_dx == ''))
        ) {
          //console.log("R14");
          //if (ordertocheck.orderTypeVariant != "formproj") {
          return false
          //}
        }
        //if (
        //(ordertocheck.footmeasurements.c_pair != "dx_c_pa" &&
        //(ordertocheck.footmeasurements.circ_past_sx == null ||
        //ordertocheck.footmeasurements.circ_past_sx == "")) ||
        //(ordertocheck.footmeasurements.c_pair != "sx_c_pa" &&
        //(ordertocheck.footmeasurements.circ_past_dx == null ||
        //ordertocheck.footmeasurements.circ_past_dx == ""))
        //) {
        ////console.log("R15");
        //return false;
        //}
        //R15
        if (ordertocheck.shoeType == 'high') {
          if (
            (ordertocheck.footmeasurements.c_pair != 'dx_c_pa' &&
              (ordertocheck.footmeasurements.circ_leg_sx == null || ordertocheck.footmeasurements.circ_leg_sx == '')) ||
            (ordertocheck.footmeasurements.c_pair != 'sx_c_pa' &&
              (ordertocheck.footmeasurements.circ_leg_dx == null || ordertocheck.footmeasurements.circ_leg_dx == ''))
          ) {
            //if (ordertocheck.orderTypeVariant != "formproj") {
            //console.log("R15");
            return false
            //}
          }
          if (
            (ordertocheck.footmeasurements.c_pair != 'dx_c_pa' &&
              (ordertocheck.footmeasurements.high_leg_sx == null || ordertocheck.footmeasurements.high_leg_sx == '')) ||
            (ordertocheck.footmeasurements.c_pair != 'sx_c_pa' &&
              (ordertocheck.footmeasurements.high_leg_dx == null || ordertocheck.footmeasurements.high_leg_dx == ''))
          ) {
            //if (ordertocheck.orderTypeVariant != "formproj") {
            //console.log("R15");
            return false
            //}
          }
        }
      }
      //console.log('fatta R16')
      //R17
      if (ordertocheck.plan_realization == 'reali_duna') {
        //if (ordertocheck.footmeasurements.c_pair != "dx_c_pa") {
        if (!ordertocheck.isDunaInsoleDisabledSx) {
          if (!ordertocheck.footmeasurements.thick_cen_heel_sx) return false
          if (!ordertocheck.footmeasurements.thick_pla_sx) return false
          if (!ordertocheck.footmeasurements.thick_poi_sx) return false
        }
        //if (ordertocheck.footmeasurements.c_pair != "sx_c_pa") {
        if (!ordertocheck.isDunaInsoleDisabledDx) {
          if (!ordertocheck.footmeasurements.thick_cen_heel_dx) return false
          if (!ordertocheck.footmeasurements.thick_pla_dx) return false
          if (!ordertocheck.footmeasurements.thick_poi_dx) return false
        }
        //if (
        //  (ordertocheck.footmeasurements.c_pair != "dx_c_pa" &&
        //    (ordertocheck.footmeasurements.thick_cen_heel_sx == null ||
        //      ordertocheck.footmeasurements.thick_cen_heel_sx == "")) ||
        //  (ordertocheck.footmeasurements.c_pair != "sx_c_pa" &&
        //    (ordertocheck.footmeasurements.thick_cen_heel_dx == null ||
        //      ordertocheck.footmeasurements.thick_cen_heel_dx == ""))
        //) {
        //  console.log("R17");
        //  return false;
        //}
        //if (
        //  (ordertocheck.footmeasurements.c_pair != "dx_c_pa" &&
        //    (ordertocheck.footmeasurements.thick_pla_sx == null ||
        //      ordertocheck.footmeasurements.thick_pla_sx == "")) ||
        //  (ordertocheck.footmeasurements.c_pair != "sx_c_pa" &&
        //    (ordertocheck.footmeasurements.thick_pla_dx == null ||
        //      ordertocheck.footmeasurements.thick_pla_dx == ""))
        //) {
        //  console.log("R17");
        //  return false;
        //}
        //if (
        //  (ordertocheck.footmeasurements.c_pair != "dx_c_pa" &&
        //    (ordertocheck.footmeasurements.thick_poi_sx == null ||
        //      ordertocheck.footmeasurements.thick_poi_sx == "")) ||
        //  (ordertocheck.footmeasurements.c_pair != "sx_c_pa" &&
        //    (ordertocheck.footmeasurements.thick_poi_dx == null ||
        //      ordertocheck.footmeasurements.thick_poi_dx == ""))
        //) {
        //  console.log("R17");
        //  return false;
        //}
      }
      //R18
      // if (ordertocheck.plan_realization == "reali_proper") {
      //   if (
      //     (ordertocheck.footmeasurements.c_pair != "dx_c_pa" &&
      //       (ordertocheck.footmeasurements.plant_sx == null ||
      //         ordertocheck.footmeasurements.plant_sx == "")) ||
      //     (ordertocheck.footmeasurements.c_pair != "sx_c_pa" &&
      //       (ordertocheck.footmeasurements.plant_dx == null ||
      //         ordertocheck.footmeasurements.plant_dx == ""))
      //   ) {
      //     //console.log("R18");
      //     return false;
      //   }
      //   if (
      //     (ordertocheck.footmeasurements.c_pair != "dx_c_pa" &&
      //       (ordertocheck.footmeasurements.tacc_sx == null ||
      //         ordertocheck.footmeasurements.tacc_sx == "")) ||
      //     (ordertocheck.footmeasurements.c_pair != "sx_c_pa" &&
      //       (ordertocheck.footmeasurements.tacc_dx == null ||
      //         ordertocheck.footmeasurements.tacc_dx == ""))
      //   ) {
      //     //console.log("R18");
      //     return false;
      //   }
      // }
      //R19
      //if (ordertocheck.orderTypeMain != "last" && ordertocheck.orderTypeMain != "mold") {
      if (
        ordertocheck.orderTypeVariant != 'formproj' &&
        ordertocheck.orderTypeMain != 'last' &&
        ordertocheck.orderTypeMain != 'mold'
      ) {
        if (
          (ordertocheck.footmeasurements.c_pair != 'dx_c_pa' &&
            (ordertocheck.footmeasurements.measure_sx == null || ordertocheck.footmeasurements.measure_sx == '')) ||
          (ordertocheck.footmeasurements.c_pair != 'sx_c_pa' &&
            (ordertocheck.footmeasurements.measure_dx == null || ordertocheck.footmeasurements.measure_dx == ''))
        ) {
          //console.log(ordertocheck.orderTypeMain)
          //console.log("R19");
          return false
        }
      }

      //R20
      //RC17 A5.1rev2 Se 'solo tomaie' non è compilabile
      if (
        (!ordertocheck.mod.custom || (ordertocheck.mod.from_duna_catalog && !ordertocheck.mod.color_bool)) &&
        ordertocheck.deliverySelected !== 'testshoes' &&
        ordertocheck.deliverySelected !== 'onlyforme' &&
        ordertocheck.deliverySelectedSub !== 'onlytom' &&
        ordertocheck.deliverySelectedSub !== 'trymont'
      ) {
        if (ordertocheck.footmeasurements.c_pair != 'dx_c_pa') {
          if (ordertocheck.footmeasurements.high_heel_sx == null || ordertocheck.footmeasurements.high_heel_sx === '') {
            if (!ordertocheck.mod.tacc && !ordertocheck.footmeasurements.thick_cen_heel_sx) {
              //console.log("R20_sx");
              return false
            }
          }
        }
        if (ordertocheck.footmeasurements.c_pair != 'sx_c_pa') {
          if (ordertocheck.footmeasurements.high_heel_dx == null || ordertocheck.footmeasurements.high_heel_dx === '') {
            if (!ordertocheck.mod.tacc && !ordertocheck.footmeasurements.thick_cen_heel_dx) {
              //console.log("R20_dx");
              return false
            }
          }
        }
      }
      //if (ordertocheck.deliverySelected != "onlytom") {
      //  if (
      //    ordertocheck.footmeasurements.c_pair != "dx_c_pa" &&
      //    (ordertocheck.footmeasurements.high_heel_zep_sx == null ||
      //      ordertocheck.footmeasurements.high_heel_zep_sx == "")
      //  ) {
      //    if (
      //      ordertocheck.mod.tacc == "foggiafondo2" &&
      //      (ordertocheck.footmeasurements.thick_cen_heel_sx == null ||
      //        ordertocheck.footmeasurements.thick_cen_heel_sx == "")
      //    ) {
      //      //R20
      //      //console.log("R20_SX");
      //      return false;
      //    }
      //  }
      if (
        ordertocheck.deliverySelected !== 'onlyforme' &&
        ordertocheck.deliverySelectedSub !== 'onlytom' &&
        ordertocheck.deliverySelectedSub !== 'trymont'
      ) {
        //if ((ordertocheck.mod.tacc == "foggiafondo2" && !ordertocheck.footmeasurements.ext_high_heel_dx)) {}
        if (ordertocheck.footmeasurements.c_pair != 'sx_c_pa' && !ordertocheck.footmeasurements.high_heel_zep_dx) {
          if (
            ordertocheck.mod.tacc !== 'foggiafondo2' ||
            (ordertocheck.mod.tacc == 'foggiafondo2' && !ordertocheck.footmeasurements.ext_high_heel_dx)
          ) {
            //R20
            //console.log("R20_DX");
            return false
          }
        }
        if (ordertocheck.footmeasurements.c_pair != 'dx_c_pa' && !ordertocheck.footmeasurements.high_heel_zep_sx) {
          if (
            ordertocheck.mod.tacc !== 'foggiafondo2' ||
            (ordertocheck.mod.tacc == 'foggiafondo2' && !ordertocheck.footmeasurements.ext_high_heel_sx)
          ) {
            //R20
            //console.log("R20_SX");
            return false
          }
        }
      }

      //if (
      //  ordertocheck.footmeasurements.c_pair != "sx_c_pa" &&
      //  (ordertocheck.footmeasurements.high_heel_zep_dx == null ||
      //    ordertocheck.footmeasurements.high_heel_zep_dx == "")
      //) {
      //  if (
      //    ordertocheck.mod.tacc == "foggiafondo2" &&
      //    (ordertocheck.footmeasurements.thick_cen_heel_dx == null ||
      //      ordertocheck.footmeasurements.thick_cen_heel_dx == "")
      //  ) {
      //    //R20
      //    //console.log("R20_DX");
      //    return false;
      //  }
      //}
      //}
      //console.log('fatta regola 21')
      //R22
      if (ordertocheck.orderTypeMain == 'digitalMeasurements' && ordertocheck.orderTypeVariant != 'formproj') {
        let nofile = true
        if (
          ordertocheck.attachment.scan_fms_sx != null &&
          ordertocheck.attachment.scan_pln_sx != null &&
          ordertocheck.attachment.scan_stl_sx != null &&
          ordertocheck.attachment.scan_fms_dx != null &&
          ordertocheck.attachment.scan_pln_dx != null &&
          ordertocheck.attachment.scan_stl_dx != null
        ) {
          nofile = false
        } else if (ordertocheck.attachment.scan_no_duna_sx != null && ordertocheck.attachment.scan_no_duna_dx != null) {
          nofile = false
        }
        if (nofile) {
          //console.log("R22");
          return false
        }
      } else if (ordertocheck.orderTypeMain == 'digitalMeasurements' && ordertocheck.orderTypeVariant == 'formproj') {
        let nofile = true
        if (ordertocheck.attachment.scan_no_duna_sx != null && ordertocheck.attachment.scan_no_duna_dx != null) {
          nofile = false
        }
        if (nofile) {
          //console.log("R22");
          return false
        }
      }
      //RC17 A5.1rev2 Se 'solo tomaie' non è obbligatorio
      if (ordertocheck.deliverySelected != 'onlytom') {
        //R23
        //if (
        //  ordertocheck.typecontr_sx == null ||
        //  ordertocheck.typecontr_dx == null ||
        //  ordertocheck.tipocontr_sx == null ||
        //  ordertocheck.tipocontr_dx == null ||
        //  ordertocheck.tipocontr_var_sx == null ||
        //  ordertocheck.tipocontr_var_dx == null
        //) {
        //  //console.log("R23");
        //  return false;
        //}
        if (
          ordertocheck.typecontr_sx != 'Noone' &&
          (ordertocheck.typecontr_sx == null ||
            ordertocheck.tipocontr_sx == null ||
            ordertocheck.tipocontr_var_sx == null)
        ) {
          //console.log("R23");
          return false
        }
        if (
          ordertocheck.typecontr_dx != 'Noone' &&
          (ordertocheck.typecontr_dx == null ||
            ordertocheck.tipocontr_dx == null ||
            ordertocheck.tipocontr_var_dx == null)
        ) {
          //console.log("R23");
          return false
        }
        //R24
        //if (
        //ordertocheck.typecontr_sx == null ||
        //ordertocheck.typecontr_dx == null ||
        //ordertocheck.tipocontr_sx == null ||
        //ordertocheck.tipocontr_dx == null ||
        //ordertocheck.tipocontr_var_sx == null ||
        //ordertocheck.tipocontr_var_dx == null
        //) {
        ////console.log("R24");
        //return false;
        //}
        //R25
        if (
          ordertocheck.tiposott_sx == null ||
          ordertocheck.tiposott_dx == null ||
          ordertocheck.tiposott_var_sx == null ||
          ordertocheck.tiposott_var_dx == null
        ) {
          //console.log("R25");
          return false
        }
        //R26
        //if (
        //  ordertocheck.tipopunt_mat_sx == null ||
        //  ordertocheck.tipopunt_mat_dx == null ||
        //  ordertocheck.tipopunt_mat_var_sx == null ||
        //  ordertocheck.tipopunt_mat_var_dx == null
        //) {
        //  //console.log("R26");
        //  return false;
        //}
        //R26
        if (
          ordertocheck.tipopunt_sx != 'tipopunt1' &&
          (ordertocheck.tipopunt_mat_sx == null || ordertocheck.tipopunt_mat_var_sx == null)
        ) {
          //console.log("R26");
          return false
        }
        if (
          ordertocheck.tipopunt_dx != 'tipopunt1' &&
          (ordertocheck.tipopunt_mat_dx == null || ordertocheck.tipopunt_mat_var_dx == null)
        ) {
          //console.log("R26");
          return false
        }
      }

      if (
        (ordertocheck.mod.suola_finn_sx && ordertocheck.mod.smuss_post_sx == null) ||
        (ordertocheck.mod.suola_finn_dx && ordertocheck.mod.smuss_post_dx == null)
      ) {
        //console.log("RC9 A5.1rev2");
        return false
      }
      //console.log('finite regole misure')
      //REGOLE MINIME PLANTARE
      if (ordertocheck.plan_realization == 'reali_duna') {
        if (!ordertocheck.isDunaInsoleDisabledSx) {
          if (ordertocheck.plantar_type_sx == 'Noone') return false
          if (!ordertocheck.footmeasurements.base_mat_sx) return false
          if (!ordertocheck.footmeasurements.base_matvar_sx) return false
        }
        if (!ordertocheck.isDunaInsoleDisabledDx) {
          if (ordertocheck.plantar_type_dx == 'Noone') return false
          if (!ordertocheck.footmeasurements.base_mat_dx) return false
          if (!ordertocheck.footmeasurements.base_matvar_dx) return false
        }
      }
      //if (ordertocheck.plan_realization == 'reali_duna' && (ordertocheck.footmeasurements.plantar_type_dx == 'Noone' || ordertocheck.footmeasurements.plantar_type_sx == 'Noone')) {
      //  console.log('regola plantare 1')
      //  return false
      //}
      //if (ordertocheck.plan_realization == 'reali_duna' && (!ordertocheck.footmeasurements.base_mat_sx  || !ordertocheck.footmeasurements.base_mat_dx)) {
      //  console.log('regola plantare 2')
      //  return false
      //}

      return true
    },
    getPatalogies(newarray) {
      this.$db
        .collection('pathologies')
        .get()
        .then(docs => {
          docs.forEach(doc => {
            let pathology = doc.data()
            pathology.id = doc.id
            newarray.push(pathology)
          })
          return
        })
    },
    async loadPatientStatfromOrder() {
      this.patient = this.order.patient
      this.patient.id = this.order.patientId
      const collectedPrecPair = []
      const collectedPrecOrder = []
      const collectedPrecPairShoes = []
      await this.$db
        .collection('orders')
        .where('patientId', '==', this.order.patientId)
        .get()
        .then(async orders => {
          orders.forEach(doc => {
            if (this.order.id !== doc.id && doc.data().primaryCode !== '' && doc.data().statusOrder !== 'compord') {
              collectedPrecPair.push(doc.data().primaryCode)
              if ((doc.data().module || 'tailored') === 'insole') {
                collectedPrecOrder.push(doc.data().primaryCode)
              } else {
                collectedPrecPairShoes.push(doc.data().primaryCode)
              }
            }
          })
        })
      this.$set(this.patient, 'prec_pair', collectedPrecPair)
      this.$set(this.patient, 'prec_order', collectedPrecOrder)
      this.$set(this.patient, 'prec_pair_shoes', collectedPrecPairShoes)
      for (let module of this.$modules) {
        const { bdictionary, ddictionary, bdictionaryName, ddictionaryName } = this.$moduleConfiguration[module]
        let type = this.$availableOrderType[module].find(temp => temp.key === this.order.company[bdictionary])
        let delivery = this.$availableDeliveryType[module].find(temp => temp.key === this.order.company[ddictionary])
        if (type !== undefined) {
          this[bdictionary] = type.variant
          this[bdictionaryName] = type.key
        } else {
          this[bdictionary] = []
          this[bdictionaryName] = ''
        }
        if (delivery !== undefined) {
          this[ddictionary] = delivery.variant
          this[ddictionaryName] = delivery.key
        } else {
          this[ddictionary] = []
          this[ddictionaryName] = ''
        }
      }
      // let temp = this.$availableOrderType.find(temp => temp.key === this.order.company.bdictionary)
      // if (temp != undefined) {
      //   this.bdictionary = temp.variant
      //   this.bDictionaryName = temp.key
      // } else {
      //   this.bdictionary = []
      //   this.bDictionaryName = ''
      // }
      // temp = this.$availableOrderTypeFits.find(temp => temp.key === this.order.company.bdictionary_fits)
      // if (temp !== undefined) {
      //   this.bdictionary_fits = temp.variant
      //   this.bDictionaryNameFits = temp.key
      // } else {
      //   this.bdictionary_fits = []
      //   this.bDictionaryNameFits = ''
      // }
      // temp = this.$availableDeliveryType.find(temp => temp.key === this.order.company.ddictionary)
      // if (temp != undefined) {
      //   this.ddictionary = temp.variant
      //   this.dDictionaryName = temp.key
      // } else {
      //   this.ddictionary = []
      //   this.dDictionaryName = temp.key
      // }
      // temp = this.$availableDeliveryTypeFits.find(temp => temp.key === this.order.company.ddictionary_fits)
      // if (temp !== undefined) {
      //   this.ddictionary_fits = temp.variant
      //   this.dDictionaryNameFits = temp.key
      // } else {
      //   this.ddictionary_fits = []
      //   this.dDictionaryNameFits = ''
      // }
      this.pathologiesbool = this.order.company.pathologiesbool
      await this.$db
        .collection('companies')
        .doc(this.order.companyId)
        .get()
        .then(async com => {
          if (com.data().orders) {
            this.patient.progressivenumber = com.data().orders.length + 1
          } else {
            this.patient.progressivenumber = 1
          }
          if (!this.order.module) {
            this.order.module = 'tailored'
          }
          const { catalogType } = this.$moduleConfiguration[this.order.module]
          if (com.data()[catalogType]) {
            await this.$db
              .collection('catalogs')
              .doc(com.data()[catalogType])
              .get()
              .then(doc => {
                this.catalog = doc.data()
                this.isSaveDisabled = false
                this.$forceUpdate()
              })
          } else {
            this.isSaveDisabled = false
            this.$forceUpdate()
          }
        })
    },
    isWaitForMaterialsOrder(order) {
      if (order.module === 'tailored') {
        return (
          order.orderType == 'relatedOrder' ||
          (order.orderType == 'firstOrder' &&
            (order.orderTypeMain == 'mold' || (order.orderTypeMain == 'last' && order.orderTypeSubVariant != 'file3D')))
        )
      } else {
        return false
      }
    },
    async loadPatientStat() {
      await this.$db
        .collection('patients')
        .doc(this.patientId)
        .get()
        .then(async pat => {
          this.patient = pat.data()
          const collectedPrecPair = []
          const collectedPrecOrder = []
          const collectedPrecPairShoes = []
          await this.$db
            .collection('orders')
            .where('patientId', '==', this.patientId)
            .get()
            .then(async orders => {
              orders.forEach(doc => {
                if (this.order.id !== doc.id && doc.data().primaryCode !== '' && doc.data().statusOrder !== 'compord') {
                  collectedPrecPair.push(doc.data().primaryCode)
                  if ((doc.data().module || 'tailored') === 'insole') {
                    collectedPrecOrder.push(doc.data().primaryCode)
                  } else {
                    collectedPrecPairShoes.push(doc.data().primaryCode)
                  }
                }
              })
            })
          this.$set(this.patient, 'prec_pair', collectedPrecPair)
          this.$set(this.patient, 'prec_order', collectedPrecOrder)
          this.$set(this.patient, 'prec_pair_shoes', collectedPrecPairShoes)

          await this.$db
            .collection('shops')
            .doc(pat.data().shopId)
            .get()
            .then(async sho => {
              this.patient.shopData = sho.data()
              await this.$db
                .collection('companies')
                .doc(sho.data().companyId)
                .get()
                .then(async com => {
                  for (let module of this.$modules) {
                    const { bdictionary, ddictionary, bdictionaryName, ddictionaryName } = this.$moduleConfiguration[
                      module
                    ]
                    let type = this.$availableOrderType[module].find(temp => temp.key === com.data()[bdictionary])
                    let delivery = this.$availableDeliveryType[module].find(
                      temp => temp.key === com.data()[ddictionary]
                    )
                    if (type !== undefined) {
                      this[bdictionary] = type.variant
                      this[bdictionaryName] = type.key
                    } else {
                      this[bdictionary] = []
                      this[bdictionaryName] = ''
                    }
                    if (delivery !== undefined) {
                      this[ddictionary] = delivery.variant
                      this[ddictionaryName] = delivery.key
                    } else {
                      this[ddictionary] = []
                      this[ddictionaryName] = ''
                    }
                  }
                  // let temp = this.$availableOrderType.find(temp => temp.key === com.data().bdictionary)
                  // if (temp !== undefined) {
                  //   this.bdictionary = temp.variant
                  //   this.bDictionaryName = temp.key
                  // } else {
                  //   this.bdictionary = []
                  //   this.bDictionaryName = ''
                  // }
                  // temp = this.$availableOrderTypeFits.find(temp => temp.key === com.data().bdictionary_fits)
                  // if (temp !== undefined) {
                  //   this.bdictionary_fits = temp.variant
                  //   this.bDictionaryNameFits = temp.key
                  // } else {
                  //   this.bdictionary_fits = []
                  //   this.bDictionaryNameFits = ''
                  // }
                  // temp = this.$availableDeliveryType.find(temp => temp.key === com.data().ddictionary)
                  // if (temp !== undefined) {
                  //   this.ddictionary = temp.variant
                  //   this.dDictionaryName = temp.key
                  // } else {
                  //   this.ddictionary = []
                  //   this.dDictionaryName = ''
                  // }
                  // temp = this.$availableDeliveryTypeFits.find(temp => temp.key === com.data().ddictionary_fits)
                  // if (temp !== undefined) {
                  //   this.ddictionary_fits = temp.variant
                  //   this.dDictionaryNameFits = temp.key
                  // } else {
                  //   this.ddictionary_fits = []
                  //   this.dDictionaryNameFits = ''
                  // }
                  this.pathologiesbool = com.data().pathologiesbool
                  this.order.patient = this.patient

                  this.order.shop = sho.data()
                  delete this.order.shop.searchArray
                  delete this.order.shop.orders
                  delete this.order.shop.company
                  this.order.shop.id = sho.id
                  this.order.shopId = sho.id

                  this.order.company = com.data()
                  delete this.order.company.searchArray
                  delete this.order.company.orders
                  this.order.company.id = com.id
                  this.order.companyId = com.id

                  if (this.order.company.orders) {
                    this.patient.progressivenumber = this.order.company.orders.length + 1
                  } else {
                    this.patient.progressivenumber = 1
                  }
                  const { catalogType } = this.$moduleConfiguration[this.order.module]
                  if (com.data()[catalogType]) {
                    await this.$db
                      .collection('catalogs')
                      .doc(com.data()[catalogType])
                      .get()
                      .then(doc => {
                        this.catalog = doc.data()
                        this.isSaveDisabled = false
                        this.$forceUpdate()
                      })
                  } else {
                    this.isSaveDisabled = false
                    this.$forceUpdate()
                  }
                })
            })
        })
    },
    changeStatus(order, newStatusOrder) {
      //se riesce a cambiare l'ordine torna false, altrimenti true
      if (!this.isTransitionDoable(order.statusOrder, newStatusOrder, order)) return false
      this.changeOrderStatus(order, newStatusOrder)
      return true
    },
    changeGroupStatus(orders, newStatusOrder) {
      //controlla se può cambiare lo stato dell'ordine di tutto il gruppo
      //se riesce a cambiare l'array torna true, altrimenti false
      if (orders.length === 0) return false
      if (orders[0].statusOrder == newStatusOrder) return false
      let oldStatusOrder = orders[0].statusOrder
      for (let order in orders) {
        if (orders[order].module === 'fits' && newStatusOrder === 'waitord') return false
        ////console.log(order);
        if (orders[order].statusOrder !== oldStatusOrder) return false
        if (!this.isTransitionDoable(orders[order].statusOrder, newStatusOrder, orders[order])) return false
      }
      /*
      orders.forEach((order) => {
        if (order.statusOrder != oldStatusOrder) return false;
        if (!this.isTransitionDoable(order.statusOrder, newStatusOrder, order)) return false;
      });
      */
      orders.forEach(order => {
        this.changeOrderStatus(order, newStatusOrder)
      })
      return true
    },
    changeOrderStatus(order, newStatusOrder) {
      // Se lo stato è successivo a send e non ha ancora una send date la aggiunge
      if (order.send_date == null && newStatusOrder != 'compord' && newStatusOrder != 'invord') {
        order.send_date = new Date().getTime()
      }
      // Se non esiste una data di creazione la aggiunge
      if (order.creationDate == null) {
        order.creationDate = new Date().getTime()
      }
      // Se non esiste la storia dell'ordine crea un nuovo array
      if (!order.history) order.history = []
      //Cambia lo stato se da invio ordine passa in processamento ordine ma deve attendere nuovo materiale
      if (order.statusOrder == 'sendord' && newStatusOrder == 'proc_order' && this.isWaitForMaterialsOrder(order)) {
        order.history.push({
          technician: this.$store.getters.user.userInfo.username,
          date: new Date().getTime(),
          oldStatus: order.statusOrder,
          newStatus: 'proc_order',
        })
        order.statusOrder = 'proc_order'
        newStatusOrder = 'waitord'
      }
      // Aggiunge la transizione alla storia dell'ordine
      order.history.push({
        technician: this.$store.getters.user.userInfo.username,
        date: new Date().getTime(),
        oldStatus: order.statusOrder,
        newStatus: newStatusOrder,
      })
      //se l'ordine viene cancellato il flag diventa true
      order.deleted = newStatusOrder == 'deletedord'
      // Cambia lo stato dell'ordine
      order.statusOrder = newStatusOrder
    },
  },
}
